import React from 'react';
import { SAMPLE, usd } from '../sampleData';

const W = 600;
const H = 300;

export const MockChart = ({ bars = 48, showLevels = true }) => {
  const cs = SAMPLE.candles.slice(-bars);
  const e21 = SAMPLE.ema21.slice(-bars);
  const e50 = SAMPLE.ema50.slice(-bars);
  const levels = showLevels ? [['Target', SAMPLE.target, 'up'], ['Entry', SAMPLE.entry, 'accent'], ['Stop', SAMPLE.stop, 'down']] : [];
  const lo = Math.min(...cs.map((c) => c.low), ...levels.map((l) => l[1])) - 0.8;
  const hi = Math.max(...cs.map((c) => c.high), ...levels.map((l) => l[1])) + 0.8;
  const step = W / bars;
  const x = (i) => (i + 0.5) * step;
  const y = (v) => ((hi - v) / (hi - lo)) * H;
  const path = (arr) => arr.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join('');

  return (
    <div className="mk-chart">
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true" focusable="false">
        {[0.25, 0.5, 0.75].map((g) => <line key={g} x1="0" x2={W} y1={H * g} y2={H * g} className="mk-chart-grid" vectorEffect="non-scaling-stroke" />)}
        {cs.map((c, i) => {
          const up = c.close >= c.open;
          return (
            <g key={i} className={up ? 'mk-c-up' : 'mk-c-down'}>
              <line x1={x(i)} x2={x(i)} y1={y(c.high)} y2={y(c.low)} vectorEffect="non-scaling-stroke" />
              <rect x={x(i) - step * 0.3} width={step * 0.6} y={y(Math.max(c.open, c.close))} height={Math.max(1.5, Math.abs(y(c.open) - y(c.close)))} />
            </g>
          );
        })}
        <path d={path(e21)} className="mk-ema21" vectorEffect="non-scaling-stroke" />
        <path d={path(e50)} className="mk-ema50" vectorEffect="non-scaling-stroke" />
        {levels.map(([l, v, c]) => <line key={l} x1="0" x2={W} y1={y(v)} y2={y(v)} className={`mk-level ${c}`} vectorEffect="non-scaling-stroke" />)}
      </svg>
      {levels.map(([l, v, c]) => (
        <span key={l} className={`mk-chart-tag ${c}`} style={{ top: `${(y(v) / H) * 100}%` }}>{l} <span className="mk-num">{usd(v)}</span></span>
      ))}
      <div className="mk-chart-legend" aria-hidden="true"><span className="e21">EMA 21</span><span className="e50">EMA 50</span></div>
    </div>
  );
};
